"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

exports.__esModule = true;
exports.buttonPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var buttonPropTypes = {
  children: _propTypes.node,
  circular: _propTypes.bool,
  disabled: _propTypes.bool,
  fullWidth: _propTypes.bool,
  iconEnd: _propTypes.element,
  iconStart: _propTypes.element,
  minimal: _propTypes.bool,
  onClick: _propTypes.func,
  primary: _propTypes.bool,
  size: (0, _propTypes.oneOf)(Object.keys(_constants.SIZE)),
  type: _propTypes.string,
  variant: (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT))
};
exports.buttonPropTypes = buttonPropTypes;